import { Component, OnInit, ViewEncapsulation, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MenuItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { GlobalService } from './../../core/';
import { GlobalNamespace as _GlobalNS } from './../../../environments/environment';
import { OfferServiceService } from '../offer-service.service';
import { Offer } from '../offer';

@Component({
  selector: 'app-offer-dashboard'
  , templateUrl: './offer-dashboard.component.html'
  , styleUrls: ['./offer-dashboard.component.scss']
  , encapsulation: ViewEncapsulation.None
  , providers: []
})

export class OfferDashboardComponent implements OnInit {

  loading = false;
  offers: Offer[];
  updatedOffers: Offer[];
  totalRecords = 0;
  paginationInfo = { offset: 0, pageSize: 10, sortValue: '', sortDir: '' };
  showFilterSideBar = false;
  filterExpand = false;
  loadDefault: boolean;
  allOfferStatus = [
    {label: 'New', inputId: 'new', value: 'new'},
    {label: 'Negotiating', inputId: 'negotiating', value: 'negotiating'},
    {label: 'Rejected', inputId: 'rejected', value: 'rejected'},
    {label: 'Held', inputId: 'held', value: 'held'},
    {label: 'Accepted', inputId: 'accepted', value: 'accepted'}
  ];
  selectedLoanNumber = '';
  expandedRows = {};
  @ViewChild('offerTable') table: Table;

  public sidebarFilterForm: FormGroup = new FormGroup({
    LoanNumber: new FormControl('', [Validators.required]),
    FilterOfferStatus:  new FormControl('', [Validators.required])
  });
  loanNumber = this.sidebarFilterForm.get('LoanNumber');
  filterOfferStatus = this.sidebarFilterForm.get('FilterOfferStatus');

  constructor(private _global: GlobalService
    , private offerServiceService: OfferServiceService
    , private elementRef: ElementRef
    ) {}

  ngOnInit() {
    this.loading = true;
    this.loadDefault = true;
    this.loadOfferData();
  }

  loadOfferData(): any {    
    this.loading = true;
    this.expandedRows = {};
    this.offerServiceService.getOffers(this.paginationInfo, this.selectedLoanNumber, this.filterOfferStatus.value, this.loadDefault)
    .subscribe(offerData => {
        this.loading = false;
        this.offers = (<any>offerData).data;
        this.totalRecords = (<any>offerData).meta.pagination.TotalRecords;
        this.showFilterSideBar = false;        
      },
      error => {
        this.loading = false;
        console.log('Error occurred while fetching offers');
        throw new Error('Error occurred while fetching offers');
      });
  }

  loadNextSet(event): void {
    this.paginationInfo = {
      offset: (event.first !== undefined ? event.first : this.paginationInfo.offset)
      , pageSize: (event.rows !== undefined ? event.rows : this.paginationInfo.pageSize)
      , sortDir: ''
      , sortValue: event.sortField ? event.sortField : ''
    };
    this.loadOfferData();
  }

  getActionItems(data: any): any[] {
    const menuArray: MenuItem[] = [];
    if (data.CanAccept) {
      menuArray.push({label: 'Accept', command: () => {data.Action = 'Accept'; data.CancelAction = true; this.expandedRows[data.OfferId] = 1;} });
    }
    if (data.CanReject) {
      menuArray.push({label: 'Reject', command: () => {data.Action = 'Reject'; data.CancelAction = true; data.expanded = true; this.expandedRows[data.OfferId] = 1;} });
    }
    if (data.CanCounter) {
      menuArray.push({label: 'Counter', command: () => {data.Action = 'Counter'; data.CancelAction = true; data.expanded = true; this.expandedRows[data.OfferId] = 1;} });
    }
    if (data.CanHighestAndBest) {
      menuArray.push({label: 'H&B', command: () => {data.Action = 'HighestAndBest'; data.CancelAction = true; data.expanded = true; this.expandedRows[data.OfferId] = 1;} });
    }
    return menuArray;
  }

  cancelOfferUpdate(data: Offer) {
    data.Action = '';
    data.CancelAction = false;
    data.EnableCounter = false;
  }

  enableCounterButton(event: any, data): void {
    const pattern = new RegExp('^([0-9]*[.])?[0-9]+$');
    const patternMatch = pattern.test(event.target.value);
    data.IsSellerAmountInValid = false;
    if (event.target.value && event.target.value !== '' ) {
      if (!patternMatch) {
        data.IsSellerAmountInValid = true;
        data.EnableCounter = false;
      } else {
        data.IsSellerAmountInValid = false;
        data.EnableCounter = true;
      } 
    } else {
      data.EnableCounter = false;
    }
  }

  updateOffer(data: Offer, action: string): void {
    const payload = {};
    data.Processing = true;
    if (action === 'Counter') {
      /**** COUNTER ACTION ****/
      const sellerOfferAmount = this.elementRef.nativeElement.querySelector('#SellerOfferAmount-' + data.OfferId).value;
      payload['action'] = action;
      payload['offerid'] = data.OfferId;
      payload['sellerOfferAmount'] = sellerOfferAmount;
      if (data.LenderId) {
        payload['lenderId'] = data.LenderId;
      }
    } else {
      /**** ACCEPT, REJECT, H&B ACTIONS  ****/
      payload['action'] = action;
      payload['offerid'] = data.OfferId;
      if (data.LenderId) {
        payload['lenderId'] = data.LenderId;
      }
    }
    this.offerServiceService.updateOffer(payload)
      .subscribe(offerData => {
          this.loading = false;
          this.updatedOffers = (<any>offerData).data;
          this.offers.map( (offer) => {  //All offers in the result  grid
            for (let offerCount=0; offerCount<this.updatedOffers.length; offerCount++) {  //All offers recieved in response
              if (offer.OfferId === this.updatedOffers[offerCount].OfferId) { //If Update offer Id matches Existing Offer ID 
                offer.CanAccept = false;
                offer.CanReject = false;
                offer.CanCounter = false;
                offer.CanHighestAndBest = false;
                for (let offerDataPoint in this.updatedOffers[offerCount])  { // All data points in offer model 
                  offer[offerDataPoint] = this.updatedOffers[offerCount][offerDataPoint];
                }
              }
            }
          });      
          data.Processing = false;
          data.Action = '';
        },
        error => {
          data.Processing = false;
          console.log('Error occurred while updating offer');
          throw new Error('Error occurred while updating offer');
        });
  }

  showSidebarFilter(): void {
    this.showFilterSideBar = true;
  }

  resetFilter(): void {
    this.sidebarFilterForm.reset();
  }

  filterOffers(): void {
    this.loadDefault = false;
    this.paginationInfo = {
      offset: 0
      , pageSize: 10
      , sortDir: ''
      , sortValue: ''
    };
    this.selectedLoanNumber = this.loanNumber.value;
    if (this.table) {
      this.table.first = 1;
    }
    this.loadOfferData();
  }

}

